<template>
  <div :class="classes">
    <pt-page-title title="提交解读工单"></pt-page-title>
    <pt-sub-title title="客户信息"></pt-sub-title>
    <!-- form -->
    <pt-apply-form></pt-apply-form>
  </div>
</template>

<script>
// 组件class前缀
import ptApplyForm from './pt-apply-form/withData'
const prefixCls = 'pt-create-report-unscramble-apply'
export default {
  name: 'pt-create-report-unscramble-apply',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptApplyForm
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
